export const VOUCHER_EVENTS = {
  AIDE_AUX_VACANCES: "Aide aux vacances",
  CULTURE: "Culture",
  DEPART_EN_RETRAITE: "Départ en Retraite",
  FETE_ST_NICOLAS: "Fête St Nicolas",
  FETE_STE_CATHERINE: "Fête Ste Catherine",
  FETE_DES_MERES: "Fête des Mères",
  FETE_DES_PERES: "Fête des Pères",
  MARIAGE_PACS: "Mariage / PACS",
  NAISSANCE: "Naissance",
  NOEL_DES_ENFANTS: "Noël des enfants",
  NOEL_DES_SALARIES: "Noël des salariés",
  RENTREE_SCOLAIRE: "Rentrée scolaire",
} as const;

export type VoucherEvent = typeof VOUCHER_EVENTS[keyof typeof VOUCHER_EVENTS];

export const VOUCHER_EVENT_CONFIGS: Record<VoucherEvent, {
  bannerText: string
  modalTitle: string
  modalParagraph1: string
  modalParagraph2: string
  linkText: string
  linkUrl: string
}> = {
  [VOUCHER_EVENTS.AIDE_AUX_VACANCES]: {
    bannerText: "Découvrez comment utiliser vos bons pour vos vacances",
    modalTitle: "Utilisation des bons d'aide aux vacances",
    modalParagraph1: "Les bons Aide aux vacances vous permettent de financer vos dépenses de vacances et de loisirs.",
    modalParagraph2: "Vous pouvez utiliser vos bons pour des activités de loisirs, sorties et cadeaux dans des enseignes comme les parcs d'attractions, musées, activités créatives et sorties culturelles.",
    linkText: "Consulter les enseignes éligibles pour les vacances",
    linkUrl: "https://yeati.co/app/uploads/2024/06/Listes-enseignes-Aides-aux-Vacances-Aout-Vdef.pdf",
  },
  [VOUCHER_EVENTS.CULTURE]: {
    bannerText: "Découvrez comment utiliser vos bons pour vos activités culturelles",
    modalTitle: "Utilisation des bons Culture",
    modalParagraph1: "Les bons Culture vous permettent d'accéder à une large gamme d'activités culturelles et artistiques.",
    modalParagraph2: "Vous pouvez utiliser vos bons pour des livres, musique, films, jeux, cinémas, théâtres, musées, concerts, expositions et spectacles dans des enseignes comme les librairies, disquaires, cinémas, théâtres, musées, salles de concert et galeries d'art.",
    linkText: "Consulter les enseignes éligibles pour la culture",
    linkUrl: "https://yeati.co/app/uploads/2024/06/Liste-enseigns-evts-culture-adulte-enfants-compil.pdf",
  },
  [VOUCHER_EVENTS.DEPART_EN_RETRAITE]: {
    bannerText: "Découvrez comment utiliser vos bons pour votre départ en retraite",
    modalTitle: "Utilisation des bons Départ en Retraite",
    modalParagraph1: "Les bons Départ en Retraite vous accompagnent dans cette nouvelle étape de votre vie.",
    modalParagraph2: "Vous pouvez utiliser vos bons pour des voyages, loisirs, équipements de loisirs et activités de détente dans des enseignes comme les agences de voyage, clubs de loisirs, équipements sportifs, spa et bien-être.",
    linkText: "Consulter les enseignes éligibles pour la retraite",
    linkUrl: "https://yeati.co/app/uploads/2024/06/Liste-enseigns-retraite.pdf",
  },
  [VOUCHER_EVENTS.FETE_ST_NICOLAS]: {
    bannerText: "Découvrez comment utiliser vos bons pour la fête de St Nicolas",
    modalTitle: "Utilisation des bons Fête St Nicolas",
    modalParagraph1: "Les bons Fête St Nicolas permettent aux enfants de profiter de cette période festive.",
    modalParagraph2: "Vous pouvez utiliser vos bons pour des jouets, livres jeunesse, activités pour enfants et cadeaux dans des enseignes comme les magasins de jouets, librairies jeunesse, parcs d'attractions et activités créatives.",
    linkText: "Consulter les enseignes éligibles pour St Nicolas",
    linkUrl: "https://yeati.co/app/uploads/2024/06/Liste-enseigns-st-nicolas.pdf",
  },
  [VOUCHER_EVENTS.FETE_STE_CATHERINE]: {
    bannerText: "Découvrez comment utiliser vos bons pour la fête de Ste Catherine",
    modalTitle: "Utilisation des bons Fête Ste Catherine",
    modalParagraph1: "Les bons Fête Ste Catherine célèbrent cette tradition avec des activités culturelles.",
    modalParagraph2: "Vous pouvez utiliser vos bons pour des activités culturelles, loisirs, sorties et cadeaux dans des enseignes comme les théâtres, musées, restaurants, activités créatives et sorties culturelles.",
    linkText: "Consulter les enseignes éligibles pour Ste Catherine",
    linkUrl: "https://yeati.co/app/uploads/2024/06/Liste-enseigns-ste-catherine.pdf",
  },
  [VOUCHER_EVENTS.FETE_DES_MERES]: {
    bannerText: "Découvrez comment utiliser vos bons pour la fête des Mères",
    modalTitle: "Utilisation des bons Fête des Mères",
    modalParagraph1: "Les bons Fête des Mères permettent de célébrer cette journée spéciale avec des activités variées.",
    modalParagraph2: "Vous pouvez utiliser vos bons pour des activités de bien-être, loisirs, sorties et cadeaux dans des enseignes comme les spa, restaurants, théâtres, activités créatives et sorties culturelles.",
    linkText: "Consulter les enseignes éligibles pour la Fête des Mères",
    linkUrl: "https://yeati.co/app/uploads/2024/06/Liste-enseigns-fete-meres.pdf",
  },
  [VOUCHER_EVENTS.FETE_DES_PERES]: {
    bannerText: "Découvrez comment utiliser vos bons pour la fête des Pères",
    modalTitle: "Utilisation des bons Fête des Pères",
    modalParagraph1: "Les bons Fête des Pères permettent de célébrer cette journée spéciale avec des activités variées.",
    modalParagraph2: "Vous pouvez utiliser vos bons pour des activités sportives, loisirs, sorties et cadeaux dans des enseignes comme les équipements sportifs, restaurants, théâtres, activités de loisirs et sorties.",
    linkText: "Consulter les enseignes éligibles pour la Fête des Pères",
    linkUrl: "https://yeati.co/app/uploads/2024/06/Liste-enseigns-fete-peres.pdf",
  },
  [VOUCHER_EVENTS.MARIAGE_PACS]: {
    bannerText: "Découvrez comment utiliser vos bons pour votre mariage/PACS",
    modalTitle: "Utilisation des bons Mariage / PACS",
    modalParagraph1: "Les bons Mariage/PACS vous accompagnent dans l'organisation de votre événement spécial.",
    modalParagraph2: "Vous pouvez utiliser vos bons pour des voyages de noces, activités de loisirs, équipements et sorties dans des enseignes comme les agences de voyage, restaurants, activités de loisirs et équipements divers.",
    linkText: "Consulter les enseignes éligibles pour Mariage/PACS",
    linkUrl: "https://yeati.co/app/uploads/2024/06/Liste-enseigns-mariage-pacs.pdf",
  },
  [VOUCHER_EVENTS.NAISSANCE]: {
    bannerText: "Découvrez comment utiliser vos bons pour la naissance",
    modalTitle: "Utilisation des bons Naissance",
    modalParagraph1: "Les bons Naissance vous accompagnent dans cette belle aventure avec des activités adaptées.",
    modalParagraph2: "Vous pouvez utiliser vos bons pour des activités familiales, loisirs, sorties et équipements dans des enseignes comme les parcs d'attractions, musées, activités créatives et équipements de loisirs.",
    linkText: "Consulter les enseignes éligibles pour la Naissance",
    linkUrl: "https://yeati.co/app/uploads/2024/06/Liste-enseigns-naissance.pdf",
  },
  [VOUCHER_EVENTS.NOEL_DES_ENFANTS]: {
    bannerText: "Découvrez comment utiliser vos bons pour le noël des enfants",
    modalTitle: "Utilisation des bons Noël des enfants",
    modalParagraph1: "Les bons Noël des enfants permettent aux enfants de profiter de cette période magique.",
    modalParagraph2: "Vous pouvez utiliser vos bons pour des jouets, livres jeunesse, activités pour enfants et cadeaux dans des enseignes comme les magasins de jouets, librairies jeunesse, parcs d'attractions et activités créatives.",
    linkText: "Consulter les enseignes éligibles pour Noël des enfants",
    linkUrl: "https://yeati.co/app/uploads/2024/06/Liste-enseigns-noel-enfants.pdf",
  },
  [VOUCHER_EVENTS.NOEL_DES_SALARIES]: {
    bannerText: "Découvrez comment utiliser vos bons pour le noël des salariés",
    modalTitle: "Utilisation des bons Noël des salariés",
    modalParagraph1: "Les bons Noël des salariés vous permettent de profiter de cette période festive.",
    modalParagraph2: "Vous pouvez utiliser vos bons pour des activités culturelles, loisirs, sorties et cadeaux dans des enseignes comme les théâtres, musées, restaurants, activités créatives et sorties culturelles.",
    linkText: "Consulter les enseignes éligibles pour Noël des salariés",
    linkUrl: "https://yeati.co/app/uploads/2024/06/Liste-enseigns-noel-salaries.pdf",
  },
  [VOUCHER_EVENTS.RENTREE_SCOLAIRE]: {
    bannerText: "Découvrez comment utiliser vos bons pour la rentrée scolaire",
    modalTitle: "Utilisation des bons Rentrée scolaire",
    modalParagraph1: "Les bons Rentrée scolaire accompagnent les enfants dans leur nouvelle année scolaire.",
    modalParagraph2: "Vous pouvez utiliser vos bons pour des fournitures scolaires, livres, activités éducatives et équipements dans des enseignes comme les papeteries, librairies, magasins de fournitures et activités éducatives.",
    linkText: "Consulter les enseignes éligibles pour la rentrée scolaire",
    linkUrl: "https://yeati.co/app/uploads/2024/06/Liste-enseigns-rentree-scolaire.pdf",
  },
};
